<template>
    <div class="contract-state">
        <div class="contract-state-wrap">
            <span class="progress">
                <span class="progress-bar">
                    <span class="progress-landlord" :class="{'active': contractState == 1 || contractState == 2 || contractState == 3}">
                        <img v-if="contractState == 1 || contractState == 2 || contractState == 3" src="@/assets/img/icon/radio_blue.svg" alt="">
                        <img v-else src="@/assets/img/icon/radio_gray.svg" alt="">
                        新增合約
                    </span>
                    <span class="progress-hr" :class="{'active': contractState == 2 || contractState == 3}"></span>
                    <span class="progress-tanant" :class="{'active': contractState == 2 || contractState == 3}">
                        <img v-if="contractState == 2 || contractState == 3" src="@/assets/img/icon/radio_blue.svg" alt="">
                        <img v-else src="@/assets/img/icon/radio_gray.svg" alt="">
                        房東上傳
                    </span>
                    <span class="progress-hr" :class="{'active': contractState == 3}"></span>
                    <span class="progress-desposit" :class="{'active': contractState == 3}">
                        <img v-if="contractState == 3" src="@/assets/img/icon/radio_blue.svg" alt="">
                        <img v-else src="@/assets/img/icon/radio_gray.svg" alt="">
                        租客確認
                    </span>
                </span>
                
            </span>
        </div>
        <div class="btn-group">
            <button v-if="contractState == 3" class="level3-btn view-new-contract" @click="toLeaseMgt(), $analytics.logEvent('查看新增合約', { screen_name: '查看新增合約'})">查看新增合約</button>
            <button v-if="contractState != 3" class="border-button save" @click="saveContract(1), savePaperContract(1), $analytics.logEvent('儲存合約資料', { screen_name: '儲存合約資料'})">儲存</button>
            <button v-if="contractState == 1" class="default-button next" @click="saveContract(0), $analytics.logEvent('下一步：房東上傳', { screen_name: '下一步：房東上傳'})">下一步：房東上傳</button>
            <button v-else-if="contractState == 2" class="default-button next" @click="savePaperContract(0), $analytics.logEvent('通知租客', { screen_name: '通知租客'})" :disabled="disabledState">通知租客確認</button>
            <!-- <button class="default-button next" @click="saveContract(0)" >下一步：房東上傳</button> -->
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    props:{
        disabledState: ''
        // state: ''
    },
    methods: {
        saveContract: function (action) {
            // console.log('saveContract')
            if( this.contractState == 1){
                this.$store.dispatch('saveNewContract', action).then(()=>{
                    
                })
            }
        },
        savePaperContract: function (action) {
            // console.log('savePaperContract')
            if( this.contractState == 2){
                this.$store.dispatch('saveNewContratFile', action)
            }
            
        },
        toLeaseMgt: function () {
            window.location.href = '/landlord/leasemanagement/home?success=1'
        }
    },
    computed:{
        ...mapGetters({
            contractState: 'GET_CONTRACT_STATUS',
        })
    }
}
</script>
<style lang="scss" scoped>
    .contract-state{
        position: relative;
        display: flex;
        align-items: center;
        width: 1106px;
        height: 44px;
        padding: 14px 24px;
        border-radius: 10px;
        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
        background-color: #ffffff;
        .progress-bar{
            display: flex;
            align-items: center;
            .progress-landlord,
            .progress-tanant,
            .progress-desposit{
                display: flex;
                align-items: center;
                font-size: 12px;
                color: #a8a5a4;
                img{
                    margin-right: 8px;
                }
            }
            .progress-landlord.active,
            .progress-tanant.active,
            .progress-desposit.active{
                color: #71aae5;
            }
            .progress-landlord,
            .progress-tanant{
                width: 72px;
            }
            .progress-desposit{
                width: 85px;
            }
            .progress-hr{
                width: 208px;
                height: 1px;
                background: #cacfcd;
                margin: 0 16px;
            }
            // .progress-hr.active{
            //     background: #f5a623;
            // }
        }
        .btn-group{
            position: absolute;
            right: 24px;
            .save{
                width: 132px;
                margin-right: 12px;
            }
            .next{
                width: 200px;
            }
            .view-new-contract{
                width: 200px;
                height: 44px;
                cursor: pointer;
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .contract-state{
            width: 1096px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/newContract/ContractStatus.vue